import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {PostAuth, ClaimAccessType, OktaAuth} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';

const {post} = requestWrapper;

const requests = {
	signUp: (name: string, email: string, stakeholderType: ClaimAccessType) =>
		post<PostAuth>(endpoints.signup, {name, email, stakeholderType}),
	createPassword: ({password, token}: {token: string; password: string}) =>
		post<PostAuth>(
			endpoints.createAccount,
			{
				password,
			},
			{params: {token}},
		),
	getToken: (email: string, password: string) =>
		post<DataResponseWrapper<{token: string}>>(endpoints.getToken, {
			email,
			password,
		}),
	revokeToken: () => post<DataResponseWrapper<null>>(endpoints.revokeToken),
	oktaVerify: (email: string) =>
		post<DataResponseWrapper<OktaAuth>>(endpoints.oktaVerify, {
			email,
		}),
	oktaAuth: (code: string) =>
		post<DataResponseWrapper<{token: string}>>(endpoints.okta, {
			code,
		}),
};

export default requests;
